import { getApolloClient } from '@/lib/apollo-client'
import type { BoundsInput, PointInput, SearchFilter } from '@onxmaps/supergraph'
import { createSearchQuery, search } from '@onxmaps/search-web'

/** Custom searchConnection query to use for webmap search */
const LOCATION_SEARCH_QUERY = createSearchQuery(`
        about {
      ... on Lake {
        id
      }
      ... on FishingRegion {
        id
        area
        waterbodies {
          name
          id
          area
        } 
      }
      ... on WaterAccessSite {
        id
        primaryAmenity {
          id
          slug
        }
        parentWaterbody: waterbody {
          id
          name
        }
      }
      ... on FishingArea {
        id
        label
        coverPhoto {
          contentUrl
        }
        waterbody {
          name
        }
      }
    }
  `)

/**
 * Perform a standard search query to the onX Supergraph
 */
export const searchLocation = async (
  searchTerm: string = '',
  first: number = 50,
  location?: PointInput,
  bounds?: BoundsInput,
  filter?: SearchFilter
) => {
  const client = getApolloClient()

  return await search(client, {
    searchTerm,
    limit: first,
    location,
    bounds,
    filter,
    customQuery: LOCATION_SEARCH_QUERY,
  })
}

/**
 * Perform a landowner search query to the onX Supergraph, using a "private" searchScopeFilter
 */
export const searchPrivateLand = async (
  searchTerm: string = '',
  first: number = 50,
  location?: PointInput,
  bounds?: BoundsInput,
  filter?: SearchFilter
) => {
  // private land filter plus any passed filters
  const mergedFilter = {
    searchScopeFilter: {
      slug: {
        eq: 'private',
      },
    },
    ...filter,
  }

  const client = getApolloClient()

  return await search(client, {
    searchTerm,
    limit: first,
    location,
    bounds,
    filter: mergedFilter,
  })
}
